import {Injectable} from '@angular/core';
import {InfoService} from '../section-service.class';
import {Service} from '../../common/service.class';
import {Observable} from 'rxjs';
import {PracticeSpecialty} from './practice-specialty.model';

/**
 * Created by Rodrigo Quesada on 12/12/16.
 */
@Injectable()
export class PracticeSpecialtyService extends InfoService {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'practiceSpecialty');
    }

    getPracticeSpecialties(): Observable<Array<PracticeSpecialty>> {
        return this.getList(PracticeSpecialty);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/info/practicespecialty/practice-specialty.service.ts